import {
	CHIP_THEME,
	COLOR,
	Chips as ChipsV2,
} from '@dealstack/frontend/shared/components/Chips/Chips.v2';
import { SectionHeader } from '@dealstack/frontend/shared/components/SectionHeader/SectionHeader';
import { useTranslationMipCreate } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks';
import { memo } from 'react';
import styled from 'styled-components';

interface Props {
	className?: string;
}

const ForIndividuals = ({ className }: Props) => {
	const tMipCreate = useTranslationMipCreate();

	const personalDetailsPath = 'schedule.individuals_section.personal_details_section';

	return (
		<div className={className}>
			<SectionHeader
				size="p-lgb"
				title={tMipCreate(
					'schedule.individuals_section.personal_details_section.personal_details_title'
				)}
				subtitle={tMipCreate(
					'schedule.individuals_section.personal_details_section.personal_details_subtitle'
				)}
			/>
			<ChipsWrapper>
				<ChipsV2
					prefixIcon="checkmark-circle-contained-filled"
					size="s"
					color={COLOR.GREEN}
					chipTheme={CHIP_THEME.LIGHT}
				>
					{tMipCreate(`${personalDetailsPath}.name`)}
				</ChipsV2>
				<ChipsV2
					prefixIcon="checkmark-circle-contained-filled"
					size="s"
					color={COLOR.GREEN}
					chipTheme={CHIP_THEME.LIGHT}
				>
					{tMipCreate(`${personalDetailsPath}.address`)}
				</ChipsV2>
				<ChipsV2
					prefixIcon="checkmark-circle-contained-filled"
					size="s"
					color={COLOR.GREEN}
					chipTheme={CHIP_THEME.LIGHT}
				>
					{tMipCreate(`${personalDetailsPath}.date_of_birth`)}
				</ChipsV2>
				<ChipsV2
					prefixIcon="checkmark-circle-contained-filled"
					size="s"
					color={COLOR.GREEN}
					chipTheme={CHIP_THEME.LIGHT}
				>
					{tMipCreate(`${personalDetailsPath}.email`)}
				</ChipsV2>
				<ChipsV2
					prefixIcon="checkmark-circle-contained-filled"
					size="s"
					color={COLOR.GREEN}
					chipTheme={CHIP_THEME.LIGHT}
				>
					{tMipCreate(`${personalDetailsPath}.phone_number`)}
				</ChipsV2>
			</ChipsWrapper>
		</div>
	);
};

const ChipsWrapper = styled.div`
	display: flex;
	flex-direction: row;
	flex-wrap: wrap;
	margin: 1em 0;
	gap: 0.5em;
`;

const Memoized = memo(ForIndividuals);
const Styled = styled(Memoized)`
	${SectionHeader} {
		margin-top: 1.5em;
	}
`;

export { Styled as ForIndividuals };
